// extracted by mini-css-extract-plugin
export default {"container":"a559c1af2d960123","text":"_0a030662484aab2a","iconWrapper":"e46c7731dff30941","alwaysVisible":"_08e95a9f480d75ae","icon":"ca46db3af3d84775"};